import { createActionGroup } from '@ngrx/store';

export const ValeurFichierActions = createActionGroup({
  source: 'Valeur Fichier',
  events: {}
});
